import React from 'react'

const HorizontalCardLeftTop: React.FC<{ children?: React.ReactNode }> = props => {
    return <>{props.children}</>
}

export default HorizontalCardLeftTop
